module.exports = __webpack_public_path__ + "static/vista-4-8525262fbd051f9a37293bdb5d3d5778.jpeg";